import FlashText from './flashtext'

export const flashtext = new FlashText()
export default FlashText
